<template>
  <v-card>
    <v-container class="py-0">
      <v-row>
        <v-col>
          <v-card-title>
            Team Members
          </v-card-title>
          <v-card-subtitle>
            View and manage your team members
          </v-card-subtitle>
        </v-col>
        <v-spacer class="limited-spacer"></v-spacer>
        <v-col cols="12" sm="auto" class="my-auto">
          <v-text-field
            class="hideMessages"
            label="Search by keyword"
            single-line
            dense
            outlined
            clearable
            prepend-inner-icon="search"
            v-model="search"
            @change="getUsers"
            @click:clear="clearSearch"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="auto" class="my-auto" v-if="is_admin">
          <v-btn block color="secondary" @click="exportUsers">
            <v-icon>file_download</v-icon> Export Members
          </v-btn>
        </v-col>
        <v-col cols="12" sm="auto" class="my-auto mr-2" v-if="is_admin">
          <add-members-dialog
            v-on:save="save"
            v-on:export="exportUsers"
          ></add-members-dialog>
        </v-col>
      </v-row>
    </v-container>
    <v-card-text>
      <v-skeleton-loader
        v-if="loading"
        type="table-thead, table-tbody"
      ></v-skeleton-loader>
      <v-data-table
        v-else
        :headers="headers"
        :items="filtered_members"
        :footer-props="{
          'items-per-page-options': [10, 25, 50, 100]
        }"
        @click:row="rowClick"
        class="row-pointer"
      >
        <template v-slot:item.fullName="{ item }">
          <user-chip :user="item"></user-chip>
        </template>
        <template v-slot:item.fullTeamName="{ item }">
          <team-chip
            v-if="item.teamId"
            :team="{
              id: item.teamId,
              fullName: item.fullTeamName,
              logoUrl: item.teamLogoUrl
            }"
          ></team-chip>
        </template>
        <template v-slot:item.coreBoard="{ item }">
          <v-btn
            icon
            @click.stop="
              $router.push({ path: '/members/' + item.id + '/coreboard' })
            "
          >
            <v-icon>insert_chart</v-icon>
          </v-btn>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn
            text
            small
            class="light-background"
            color="info"
            :to="'/members/' + item.id"
          >
            View
          </v-btn>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import AddMembersDialog from "@/components/members/AddMembersDialog";
export default {
  name: "MemberList",
  components: {
    "add-members-dialog": AddMembersDialog
  },
  data: () => ({
    total: 0,
    loading: false,
    search: ""
  }),
  computed: {
    headers() {
      let list = [
        { text: "Name", value: "fullName" },
        { text: "Job Title", value: "jobTitle" },
        { text: "Status", value: "statusName" }
      ];
      if (this.settings.planType == this.$enums.companyPlanTypes.LITE) {
        list.concat([
          {
            text: "Department",
            value: "fullTeamName"
          },
          {
            text: "CoreBoard",
            value: "coreBoard",
            sortable: false
          }
        ]);
      }
      list.push({ text: "Actions", value: "actions", sortable: false });
      return list;
    },
    filtered_members() {
      let items = this.members;
      if (this.search) {
        let search = this.search.toLowerCase();
        items = items.filter(
          x =>
            x.fullName.toLowerCase().indexOf(search) >= 0 ||
            x.email.toLowerCase().indexOf(search) >= 0 ||
            (x.jobTitle || "").toLowerCase().indexOf(search) >= 0
        );
      }
      return items;
    },
    ...mapGetters({
      members: "user/users",
      tasks: "task/tasks",
      is_admin: "profile/is_admin",
      settings: "profile/settings"
    })
  },
  watch: {},
  created() {
    this.getUsers();
  },
  methods: {
    save() {
      this.getUsers();
    },
    getUsers() {
      this.loading = true;
      this.$store
        .dispatch("user/getUsers")
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while loading your members."
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    rowClick(item) {
      this.$router.push({ path: "/members/" + item.id });
    },
    clearSearch() {
      this.search = "";
    },
    exportUsers() {
      this.$store.dispatch("user/getExport").catch(error => {
        this.logError(error);
        this.$root.$alert(
          "Error Occurred",
          "An error occured while exporting your members."
        );
      });
    }
  }
};
</script>
